import * as constants from '../../common/constant';
import { events } from '../../common/constant';
/**
 * Manages block change events and their tracking for the BlockEditor.
 *
 * @hidden
 */
export class EventService {
    /**
     * Creates a new BlockCommandManager instance
     *
     * @param {BlockManager} manager The parent BlockManager instance
     */
    constructor(manager) {
        this.parent = manager;
        this.blockChanges = [];
        this.addEventListener();
    }
    addEventListener() {
        this.parent.observer.on(constants.CLEAREVENTCHANGES, this.clearEventChanges, this);
        this.parent.observer.on(events.destroy, this.destroy, this);
    }
    removeEventListener() {
        this.parent.observer.off(constants.CLEAREVENTCHANGES, this.clearEventChanges);
        this.parent.observer.off(events.destroy, this.destroy);
    }
    /**
     * Adds a block change operation to the collection.
     *
     * @param {BlockChange} change - The block change to add.
     * @returns {void}
     * @hidden
     */
    addChange(change) {
        this.blockChanges.push(change);
    }
    /**
     * Retrieves the current collection of block change operations.
     *
     * @returns {BlockChange[]} change - Array of block change operations.
     * @hidden
     */
    getChanges() {
        return this.blockChanges;
    }
    /**
     * Clears all recorded block change operations.
     *
     * @returns {void}
     * @hidden
     */
    clearEventChanges() {
        this.blockChanges = [];
    }
    destroy() {
        this.blockChanges = null;
        this.removeEventListener();
    }
}
